import { memo } from 'react';
import PropTypes from 'prop-types';

import './MetadataLabel.scss';

const MetadataLabel = ({ name }) => (
  <div
      className="ng-metadata-label"
  >
    <p>{name}</p>
    <p>METADATA</p>
  </div>
)

MetadataLabel.propTypes = {
  name: PropTypes.string.isRequired
}

export default memo(MetadataLabel)